import { render, staticRenderFns } from "./ConfirmacionModal.vue?vue&type=template&id=04f51c08&"
import script from "./ConfirmacionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmacionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports